import { TrendingUpFill } from '@lyearn/icons';
import {
  KeyResultType,
  ObjectiveCategoryConfig,
  ObjectiveType,
  ObjectiveTypeEnum,
  OkrTypeEnum,
} from '@/types/schema';

import { OBJECTIVE_TYPE_CONFIG } from './objective-type';

type KeyResultData = Pick<KeyResultType, 'type'>;
type ObjectiveData = Pick<ObjectiveType, 'type'> & {
  categoryConfig?: Pick<ObjectiveCategoryConfig, 'type'>;
};

export type OKRTypeConfigData = KeyResultData | ObjectiveData;

export const getOKRTypeConfig = (data: OKRTypeConfigData) => {
  switch (data.type) {
    case OkrTypeEnum.KeyResult: {
      return { Icon: TrendingUpFill, labelKey: 'Common:KeyResult' };
    }

    case OkrTypeEnum.Objective: {
      const objectiveType = (data as ObjectiveData).categoryConfig?.type as ObjectiveTypeEnum;

      if (objectiveType) {
        const config = OBJECTIVE_TYPE_CONFIG[objectiveType];
        return config ? { Icon: config.Icon, labelKey: config.labelKey } : null;
      }

      return null;
    }

    default: {
      return null;
    }
  }
};

export type GetOKRTypeConfigReturnType = ReturnType<typeof getOKRTypeConfig>;
